import React, { Component, useState, useEffect } from 'react';
//import { Link } from 'react-router-dom'
import { Button } from 'reactstrap';
import DataTable from 'react-data-table-component';
//import DataTableExtensions from 'react-data-table-component-extensions';
import { getScenarioDataTestRunStatusTable } from './../UserFunctions';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table'


const ExpandableScenarioComponent = ( { data,handleViewReportClick } ) => {
    const [sceneData, setSceneData] = useState([]);

    useEffect(() => {
        getScenarioDataTestRunStatusTable({data}).then((response) => {
            if(response && response.status === 200) {
                setSceneData(response.data['data'])
            }
        }
        )

    },[]);
  
    const columns = [
                    {
                      title: 'Scenario Group ID',
                      field: 'scenario_group_id',
                    },
                    {
                      title: 'Scenario UUID',
                      field: 'scenario_uuid',
                      render: (row) =><Button onClick ={(e)=>{handleViewReportClick(e,row,data,sceneData)}}> {row.scenario_uuid}</Button>
                    },
                    {
                      title: 'Scenario Status',
                      field: 'scenario_status',
                    },
                    {
                      title: 'Scenario description',
                      field: 'scenario_description',
                    },
                   ]
      
    return (
          <MaterialTable 
           title=""
           columns={columns}
           data={sceneData}     
           options={{
           filtering: true
           }}
          />       
    )
}

class TestRunStatusTableCloseLoopRevised extends Component {
//    constructor(props) {
//        super(props)
//
//    }
    render() {
        const customStyles = {
            rows: {
              style: {
                flexWrap: 'nowrap',
                minHeight: '70px',

              }
            },
            headCells: {
              style: {
                fontWeight: "bold",
                fontSize: "70px",
                display:'flex',
                backgroundColor: "white",
                padding: ".75rem",
                verticalAlign: "top",
                borderTop: "1px solid #e9ecef",
                borderBottom: "5px solid #753DFF",
                justifyContent:"center"
              },
            },
            cells: {
              style: {
                width: '200%',
                maxWidth: '70%',
                backgroundColor: "#C7C9FF",
                fontSize: "0.98rem",
                textAlign: "center",
                verticalAlign: "top",
                borderTop: "5px solid white",
                justifyContent:"center",
                borderBottom:"0"
              },
            }
          };
      
        const columns =
            [{
              name: 'Version',
              selector: 'tag_name',
              sortable: true,
               grow: '2',
               cell: row => <div style={{flexWrap: 'wrap'}}>{row.tag_name}</div>
            },
            {
              name: 'Job ID',
              selector: 'job_id',
              sortable: true,
              cell: row => <div style={{flexWrap: 'wrap'}}>{row.job_id}</div>,
              grow: '3.5'
            },
            {
              name: 'Bench Name',
              selector: 'bench_name',
              sortable: true,
              cell: row => <div style={{flexWrap: 'wrap'}}>{row.bench_name}</div>,
              grow: '2.5'
            },
            {
              name: 'CAD Topology UUID',
              selector: 'cad_topology_job_uuid',
              sortable: true,
               cell: row => <div style={{flexWrap: 'wrap'}}>{row.cad_topology_job_uuid}</div>,
               grow: '3.5'
            },
            {
              name: 'Scheduler ID',
              selector: 'scheduler_uuid',
              sortable: true,
               cell: row => <div style={{flexWrap: 'wrap'}}>{row.scheduler_uuid}</div>,
               grow: '3.5'
            },
            {
              name: 'Test Run ID',
              selector: 'test_run_id',
              sortable: true,
              cell: row => <div style={{flexWrap: 'wrap'}}>{row.test_run_id}</div>,
               grow: '3',
            },
            {
              name: 'Test Point ID',
              selector: 'test_point_id',
              sortable: true,
               grow: '0.5',
            },
            {
              name: 'Status',
              selector: 'status',
              sortable: false,
              cell: row => <div style={{flexWrap: 'nowrap'}}>{row.status}</div>,
              grow: '3'
            },
            {
              name: 'Date',
              selector: 'date',
              sortable: true,
              cell: row => <div style={{flexWrap: 'nowrap'}}>{row.date}</div>,
              grow: '3'
            },
            ];
        
        return (
            
            <section data-test = 'closedLoopTestRunStatusTableCloseLoopRevisedComponent' className="content">
                <div className="container-fluid">
                    {this.props.testRunStatus.length > 0 ?
                        <DataTable
                         className="dataTables_wrapper"
                         columns={columns}
                         customStyles={customStyles}
                         data={this.props.testRunStatus}
                         defaultSortField="id"
                         defaultSortAsc={false}
                        //  pagination
                         highlightOnHover
                         expandableRows
                         setFilter
                         expandableRowsComponent={<ExpandableScenarioComponent handleViewReportClick={this.props.onViewReportClick}/>}
                        >
                        </DataTable>
                        
                        : <div className="alert alert-secondary" role="alert" style={{height:"25rem", width:"62rem", textAlign:"center", fontSize:"xx-large" }}>
                            No data available
                        </div>
                    }
                </div>      
            </section>
        )
    }
}
ExpandableScenarioComponent.propTypes={
data:PropTypes.string,
handleViewReportClick:PropTypes.string,
testRunStatus:PropTypes.string,
onViewReportClick:PropTypes.string,
}
ExpandableScenarioComponent.defaultProps= {
data:[],
handleViewReportClick:[],
testRunStatus:[],
onViewReportClick:[],
}
TestRunStatusTableCloseLoopRevised.propTypes={
//data:PropTypes.string,
//handleViewReportClick:PropTypes.string,
testRunStatus:PropTypes.string,
onViewReportClick:PropTypes.string,
}
TestRunStatusTableCloseLoopRevised.defaultProps= {
//data:[],
//handleViewReportClick:[],
testRunStatus:[],
onViewReportClick:[],
}
// class TestRunStatusTableCloseLoopRevised extends Component {
//   //    constructor(props) {
//   //        super(props)
//   //
//   //    }
//       render() {
//           const customStyles = {
//               rows: {
//                 style: {
//                   minHeight: '72px',
//                   // maxWidth: '70%'
//                 }
//               },
//               headCells: {
//                 style: {
//                   fontWeight: "bold",
//                   fontSize: "1rem",
//                   backgroundColor: "white",
//                   padding: ".75rem",
//                   verticalAlign: "top",
//                   borderTop: "1px solid #e9ecef",
//                   borderBottom: "5px solid #753DFF",
//                   justifyContent:"center"
//                 },
//               },
//               cells: {
//                 style: {
//                   maxWidth: '70%',
//                   backgroundColor: "#C7C9FF",
//                   fontSize: "1rem",
//                   textAlign: "center",
//                   verticalAlign: "top",
//                   borderTop: "5px solid white",
//                   justifyContent:"center"
//                 },
//               }
//             };

//           const columns =
//               [{
//                 name: 'Version',
//                 selector: 'tag_name',
//                 sortable: true,
//               //   cell: row => <div style={{flexWrap: 'wrap'}}>{row.scenario_group_name}</div>
//               },
//               {
//                 name: 'Job ID',
//                 selector: 'job_id',
//                 sortable: true,
//               //   cell: row => <div style={{alignContent:"center"}}>{row.scenario_group_id}</div>
//               },
//               {
//                 name: 'Bench Name',
//                 selector: 'bench_name',
//                 sortable: true,
//               },
//               {
//                 name: 'CAD Topology UUID',
//                 selector: 'cad_topology_job_uuid',
//                 sortable: true,
//               },
//               {
//                 name: 'Scheduler ID',
//                 selector: 'scheduler_uuid',
//                 sortable: true,
//               },
//               {
//                 name: 'Test Run ID',
//                 selector: 'test_run_id',
//                 sortable: true,
//               },
//               {
//                 name: 'Test Point ID',
//                 selector: 'test_point_id',
//                 sortable: true,
//               },
//               {
//                 name: 'Status',
//                 selector: 'status',
//                 sortable: false,
//               },
//               {
//                 name: 'Result',
//                 selector: 'result',
//                 sortable: false,
//               },
//               ];

export default TestRunStatusTableCloseLoopRevised
